import React, { Component } from 'react';
import {
    Link
} from 'react-router-dom';
import Login from "./Login";

import {ResultService} from "../../services/resultService";



class Sync extends Component {
    constructor(props) {
        super(props);

        this.state = {
            checkInFailed: false,
            checkingOut: false,
            checkingIn: false
        }

        this.renderLoginComponent = this.renderLoginComponent.bind(this);
        this.renderFooter = this.renderFooter.bind(this);
        this.renderCheckIn = this.renderCheckIn.bind(this);
        this.renderCancel = this.renderCancel.bind(this);

        this.checkOut = this.checkOut.bind(this);
        this.checkIn = this.checkIn.bind(this);
        this.cancel = this.cancel.bind(this);
    }


    checkOut(proeveId, passord, partiId) {
        const { checkOutParti } = this.props;
        this.setState(() => ({
            checkingOut : true
        }));
        ResultService.checkOutParti(proeveId, passord, partiId)
            .then((parti)=>{
                this.setState(() => ({
                    checkingOut : false
                }));
                checkOutParti();

            })
            .catch((err)=> {
                alert(err.message);
                this.setState(() => ({
                    checkingOut: false
                }));
            })
    }

    checkIn() {
        const {checkInParti} = this.props;
        this.setState(() => ({
            checkingIn : true
        }));
        ResultService.checkInParti()
            .then(()=>{
                checkInParti();
                this.setState(() => ({
                    checkingIn : false
                }));
            })
            .catch((err)=> {
                alert(err);
                this.setState(() => ({
                    checkInFailed: true,
                    checkingIn : false
                }));
            });
    }

    cancel() {
        const {cancelParti} = this.props;
        ResultService.cancel();
        cancelParti();
        this.setState(() => ({
            checkInFailed : false
        }));
    }


    renderCancel() {
        if (!this.state.checkInFailed) {
            return null;
        }
        return (
            <div className="bs-callout bs-callout-danger">
                Fik ikke afsluttet mot server.
                <button className="btn btn-default" onClick={this.cancel} >
                    Fortryd og start arbejd med nytt parti
                </button>
            </div>
        );

    }

    renderLoginComponent() {
        const {partiLoaded} = this.props;
        if (partiLoaded) {
            return null;
        }
        return (
            <Login checkingOut={this.state.checkingOut} checkOut={this.checkOut} />
        );
    }

    renderCheckIn() {
        const {partiLoaded, proeveId, klasseNavn} = this.props;
        const checkingIn = this.state.checkingIn;
        if (!partiLoaded) {
            return null;
        }

        return (
            <div>
                <div className="row boxed">
                    <div className="col-sm-12">
                        <h4>Aktiv ring:</h4>
                        <h5>Prøveid: {proeveId}</h5>
                        <h5>Hold: {klasseNavn}</h5>
                        <br/>
                        <button disabled={checkingIn} onClick={() => this.checkIn() } className="btn btn-default">
                            Afslut arbejdet med ringen
                        </button>

                        <br/><br/>
                    </div>
                </div>
            </div>
        );
    }

    renderFooter() {
        const checkingIn = this.state.checkingIn;
        return (
            <nav className="navbar navbar-default navbar-fixed-bottom">
                <div className="container">
                    <Link to="/">
                        <button disabled={checkingIn} className="btn btn-primary navbar-btn">Deltager oversigt</button>
                    </Link>
                </div>
            </nav>

        );
    }



    render() {

        return (
            <div>
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12">
                            <h2>Hold administration</h2>
                        </div>
                    </div>

                    {this.renderLoginComponent()}

                    {this.renderCheckIn()}

                    {this.renderCancel()}

                    {this.renderFooter()}

                </div>
            </div>
        );
    }
}
export default Sync;





// WEBPACK FOOTER //
// ./src/pages/sync/Sync.js